<template>
  <div>
    <div class="d-flex justify-space-between mb-5">
      <div>
        <div class="page-title mb-2">ข้อเสนอโครงการ</div>
        <div class="d-flex align-center">
          <Iconify
            icon="icon-park-solid:inbox-download-r"
            color="var(--theme-color-one)"
            class="mr-3"
          ></Iconify>
          <div v-if="isUSP">โครงการที่ส่งยื่น</div>
          <div v-if="isRSP">โครงการที่รับส่งยื่น</div>
        </div>
      </div>

      <div class="d-flex flex-column gap-12">
        <div class="d-flex gap-12">
          <div class="flex-center" style="max-width: 250px">
            <div class="min-width-max">สถานะ</div>
            <SelectBox
                placeholder="สถานะ"
                hide-details
                clearable
                :items="statusMaster"
                @onChange="searchData.status = $event; getFormCList()"
            ></SelectBox>
          </div>

          <div style="max-width: 250px">
            <TextField
              hide-details
              placeholder="ค้นหา"
              append-inner-icon="search"
              @onChange="searchData.keyword = $event"
              @onEnter="getFormCList()"
            ></TextField>
          </div>
        </div>
      </div>
    </div>

    <div>
      <div class="d-flex justify-space-between table-head">
        <div
          v-for="(item, i) in isRSP ? tableHeaderRSP : tableHeader"
          :key="i"
          :style="{ width: item.width }"
        >
          {{ item.name }}
        </div>
      </div>

      <div class="list-layout">
        <PlanOfferItem
          v-for="(item, i) in plans"
          :key="i"
          :item="item"
          :index="i"
          :headers="isRSP ? tableHeaderRSP : tableHeader"
          @onUpdateStatus="(status) => onUpdateStatus(status, item.id)"
        ></PlanOfferItem>
      </div>
    </div>

    <v-pagination
        class="mt-6"
        v-model="paginate.current_page"
        :length="paginate.last_page"
        color="#DE7033"
        @input="getFormCList"
    ></v-pagination>
  </div>
</template>

<script>
import TextField from "../../components/input/TextField";
import SelectBox from "../../components/input/SelectBox";
import PlanOfferItem from "../../components/PlanOfferItem";
import { mapState } from "vuex";

export default {
  name: "PlanOfferList",
  components: {
    TextField,
    SelectBox,
    PlanOfferItem,
  },
  data() {
    return {
      tableHeader: [
        {
          name: "",
          width: "8%",
        },
        {
          name: "ลำดับ",
          width: "6%",
        },
        {
          name: "รหัสโครงการ",
          width: "12%",
        },
        {
          name: "ชื่อโครงการ",
          width: "26%",
        },
        {
          name: "เเผนงานที่ยื่น",
          width: "26%",
        },
        {
          name: "ผู้นำเข้าข้อมูล",
          width: "12%",
        },
        {
          name: "สถานะ",
          width: "11%",
        },
        {
          name: "",
          width: "4%",
        },
      ],
      tableHeaderRSP: [
        {
          name: "",
          width: "8%",
        },
        {
          name: "ลำดับ",
          width: "5%",
        },
        {
          name: "รหัสโครงการ",
          width: "12%",
        },
        {
          name: "ชื่อโครงการ",
          width: "19%",
        },
        {
          name: "เเผนงาน",
          width: "19%",
        },
        {
          name: "รอบที่",
          width: "6%",
        },
        {
          name: "มหาวิทยาลัย",
          width: "9%",
        },
        {
          name: "ผู้นำเข้าข้อมูล",
          width: "9%",
        },
        {
          name: "สถานะ",
          width: "14%",
        },
        {
          name: "",
          width: "4%",
        },
      ],
      plans: [
        // {
        //   plan_code: '#0127',
        //   project_name_th: 'โครงการพัฒนาเครื่องมือโดรน...',
        //   form: 'แผนงานพัฒนาขีดความสามารถทาง...',
        //   importBy: 'จักรภัทร',
        //   doc_status: 'ฉบับร่าง'
        // },
        // {
        //   plan_code: '#0127',
        //   project_name_th: 'โครงการพัฒนาเครื่องมือโดรน...',
        //   form: 'แผนงานพัฒนาขีดความสามารถทาง...',
        //   importBy: 'จักรภัทร',
        //   doc_status: 'รอพิจารณา'
        // },
        // {
        //   plan_code: '#0127',
        //   project_name_th: 'โครงการพัฒนาเครื่องมือโดรน...',
        //   form: 'แผนงานพัฒนาขีดความสามารถทาง...',
        //   importBy: 'จักรภัทร',
        //   doc_status: 'ไม่ผ่านพิจารณา'
        // }
      ],
      statusMaster: [],
      statusMasterUSP: [
          'Draft',
          'Submitted1',
          'Reject',
      ],
      statusMasterRSP: [
          'Submitted1',
          'Inception',
          'Submitted2',
          'Approved',
          'Completed',
      ],
      searchData: {
        status: null,
        keyword: null
      },
      paginate: {
        total: 1,
        per_page: 1,
        current_page: 1,
        last_page: 1,
      },
    };
  },
  created() {
    if (this.isRSP)
      this.statusMaster = this.statusMasterRSP
    else
      this.statusMaster = this.statusMasterUSP
    
      this.getFormCList();
  },
  computed: {
    ...mapState({
      isUSP: (state) => state.Auth.User.user_type === "USP",
      isRSP: (state) => state.Auth.User.user_type === "RSP",
    }),
  },
  methods: {
    async getFormCList(page) {
      let res;
      let payload = {
        page: page,
        status: this.searchData.status ?? this.statusMaster.join(','),
        keyword: this.searchData.keyword
      };
      res = await this.$apiFire("CForm/getFormCList", payload);
      this.plans = res.data.map((item, index) => {
        return {
          ...item,
          no: (res.current_page - 1) * res.per_page + index + 1
        }
      });
      this.paginate = {
        total: res.total,
        per_page: res.per_page,
        current_page: res.current_page,
        last_page: res.last_page,
      };
    },
    async onUpdateStatus(status, id) {
      let payload = {
        id,
        payload: {
          status,
        },
      };

      let res = await this.$apiFire("CForm/updateFormCStatus", payload);
      this.getFormCList();
    },
  },
};
</script>

<style scoped lang="scss">
.table-head {
  padding: 0 33px 0 36px;
  margin-bottom: 12px;
  gap: 8px;
}

.list-layout {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
</style>
